import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { SKIP_LOADING_HEADER } from '../gather-shared-components/loader/loader.interceptor';

interface HttpOptions {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  url: string;
  authenticated?: boolean;
  withCredentials?: boolean;
  headers?: HttpHeaders;
  params?: HttpParams;
  body?: any;
}

@Injectable()
export class ApiWithLoadingService {
  constructor(private http: HttpClient) {}

  /**
   * @param opts Standard HttpOptions
   * @param skipLoadingIntercept Determines whether a request will trigger a global loading notification
   */
  httpWrapper<T>(opts: HttpOptions, skipLoadingIntercept = false): Observable<any> {
    let headers = opts.headers || new HttpHeaders();
    if (!skipLoadingIntercept) {
      headers = headers.set(SKIP_LOADING_HEADER, '');
    }

    return this.http
      .request(opts.method, opts.url, {
        withCredentials: opts.withCredentials,
        responseType: 'json',
        headers,
        params: opts.params,
        body: opts.body
      })
      .pipe(shareReplay(1));
  }
}
